import React, { Component } from 'react';
import { DirectionsRenderer } from "react-google-maps";

const google = window.google;

class Directions extends Component {

    state = {
        directions: null
    }

    componentDidMount(){
        this.renderDirection(this.props);
    }

    componentWillReceiveProps(nextProps){
        let {P , D} = nextProps;
        if(P !== this.props.P || D !== this.props.D){
            this.renderDirection(nextProps);
        }
    }

    renderDirection(props) {
        let {P , D} = props;
        if(P && D){
            const DirectionsService = new google.maps.DirectionsService();
            DirectionsService.route({
            origin: new google.maps.LatLng(P.lat, P.lng),
            destination: new google.maps.LatLng(D.lat, D.lng),
            travelMode: google.maps.TravelMode.DRIVING,
            }, (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                    });
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
    }

    render() { 
        return (
            this.state.directions ?  
            <DirectionsRenderer 
                directions={this.state.directions} 
                options={{
                    suppressMarkers: true
                }}
            /> 
            : null
        )
    }
}

export default Directions
